<template>
	<div>
		<div class="fl-cabecalho no-print">
			<div class="row">
				<div class="col-lg-4 col-xs-6">
					<i class="icon icon-cadastro_usuarios"></i>
					<h3>{{ _traducao('submenu', 'cadUser').toUpperCase() }}</h3>
					<h4 @click="_exibeSub('ad')" style="cursor: pointer">
						{{ _traducao('menu', 'menuAdministracao').toUpperCase() }} {{ _traducao('menu', 'menuGeral').toUpperCase() }}
						<i class="fa fa-angle-down" aria-hidden="true"></i>
					</h4>
				</div>

				<div class="col-xs-6 col-sm-6 col-lg-4">
					<span v-if="id == 0">
						<i class="icon icon-solicitacao_nova_solicitacao icon-sub"></i>
						<h3>{{ _traducao('global', 'novo').toUpperCase() }}</h3>
					</span>

					<span v-if="id != 0">
						<i class="icon icon-editar icon-sub"></i>
						<h3>{{ _traducao('global', 'editar').toUpperCase() }}</h3>
					</span>

					<h4>{{ _traducao('global', 'usuario').toUpperCase() }}</h4>
				</div>

				<div class="col-xs-12 col-sm-12 col-lg-4">
					<button
						@click="$emit('volta-cadastro')"
						class="btn btn-default pull-right btn-lg"
						:title="_traducao('global', 'voltar')"
					>
						<i class="icon-left" style="font-size: 18px" aria-hidden="true"></i>
					</button>

					<button
						class="btn btn-default pull-right btn-lg"
						:title="_traducao('global', 'imprimir')"
						style="margin-right: 20px"
						@click="$emit('print-relatorio')"
					>
						<i class="icon-imprimir" style="font-size: 18px"></i>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ['id']
}
</script>